import { Button } from '@givebutter/primitives/button';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ContactForm from 'assets/js/pages/contacts/ContactForm';
import { SelectedContact } from 'assets/js/pages/contacts/SelectedContact';
import { Installments } from 'assets/js/pages/pledges/Installments';
import { PledgeBasicInfoForm } from 'assets/js/pages/pledges/PledgeBasicInfoForm';
import { PledgeSettingsForm } from 'assets/js/pages/pledges/PledgeSettingsForm';
import { PledgeFormValue } from 'assets/js/pages/pledges/usePledgeForm';
import * as Form from 'components/form';
import { ContactType } from 'constants/contacts';
import { InstallmentFrequency } from 'constants/pledges';
import { ContactEmail } from 'types/domain';

const PledgeForm = () => {
    const { control, path, watch, resetField, setValue } =
        Form.useGivebutterFormContext<PledgeFormValue>();
    const [rawSelectedContact, frequency] = watch(['selectedContact', 'installment_frequency']);

    const selectedContact = rawSelectedContact?.[0];
    const isEphemeralContact = selectedContact?.id === ContactForm.NewContactId;

    const resetContact = () => {
        setValue('selectedContact', []);
        resetField('emails', {
            defaultValue: [
                {
                    value: '',
                    is_primary: true,
                    type: 'personal',
                } as ContactEmail,
            ],
        });
        resetField('phones', { defaultValue: [{ value: '', is_primary: true, type: 'home' }] });
    };

    return (
        <div className="flex flex-col gap-4">
            <Form.Container>
                <Form.Label name="selectedContact">
                    Contact <Form.LabelAsterisk />
                </Form.Label>
                {(!selectedContact || isEphemeralContact) && (
                    <ContactForm.SelectContact
                        contactType={ContactType.Individual}
                        nameRequired={true}
                    />
                )}
                {!!selectedContact && !isEphemeralContact && (
                    <div className={'flex items-start gap-4'}>
                        <SelectedContact contact={selectedContact} />
                        <Button
                            variant="none"
                            color="neutral"
                            onClick={() => {
                                resetContact();
                            }}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </Button>
                    </div>
                )}
            </Form.Container>
            {isEphemeralContact && (
                <div className={'flex flex-col gap-4'}>
                    <div className="flex flex-row gap-4">
                        <ContactForm.FirstName hideAffix />
                        <ContactForm.LastName hideAffix />
                    </div>
                    <ContactForm.Emails isRequired />
                    <ContactForm.Phones />
                </div>
            )}
            <Form.Container className="flex flex-row gap-2">
                <Form.UseFormCheckboxInput control={control} name={path('notify_immediately')} />
                <div className="flex flex-col gap-1">
                    <Form.Label
                        name={path('notify_immediately')}
                        className="cursor-pointer font-medium leading-none"
                    >
                        Send email to the contact immediately
                    </Form.Label>
                    <p className="text-sm text-gray-600">
                        We'll send the pledgee an email immediately after this pledge is created.
                    </p>
                </div>
            </Form.Container>
            <PledgeBasicInfoForm />
            {frequency !== InstallmentFrequency.OneTime && (
                <div className="flex flex-col gap-4 border-t border-t-gray-200 pt-6">
                    <p className="text-lg font-medium text-gray-900">Installments</p>
                    <Installments />
                </div>
            )}
            <PledgeSettingsForm />
        </div>
    );
};

export { PledgeForm };
